export default __webpack_public_path__ + "static/media/BlueTreeCute.932b1992.jpg";